// extracted by mini-css-extract-plugin
export default {"viewBox":"index_viewBox__H0oP7"};